import Arrow from "../../../assets/images/arrow.svg";
import {
  Card,
  CardContent,
  CardDescription,
  CardLink,
  CardLinkImage,
  CardTitle,
  ImageCard,
} from "./style";

type SolutionCard = {
  title: string;
  description: string;
  image: string;
};

export default function SolutionCard({
  title,
  description,
  image,
}: SolutionCard) {
  return (
    <Card>
      <CardContent>
        <ImageCard src={image} alt={title} loading="lazy" />
        <CardTitle>{title}</CardTitle>
        <CardDescription>{description}</CardDescription>
      </CardContent>
    </Card>
  );
}
